import React from 'react';

import * as S from './styles';

type ProgressBorderProps = {
  currentStep: number;
  totalSteps: number;
};

const ProgressBorder = ({ currentStep = 0, totalSteps = 1 }: ProgressBorderProps) => {
  const calculateProgress = (currentStep: number, totalSteps: number) => {
    return (100 / totalSteps) * currentStep;
  };

  return (
    <S.Container>
      <S.Progress width={calculateProgress(currentStep, totalSteps)} />
    </S.Container>
  );
};

export default ProgressBorder;
